export default __webpack_public_path__ + "static/media/alejandro-loguercio-teaching-2.97622edc.jpg";